/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import NButton from '../../components/inputs/NButton';
import useApplicationAPI from '../../hooks/network/useApplicationAPI';
import { RouteEnums } from '../../Routes/RoutesConstant';
import useSearchHook from '../../hooks/custom-hooks/useSearchHook';
import NSearch from '../../components/inputs/NSearch';
import NTable2 from '../../components/table/NTable2';
import MobileEdit from '../../assets/svg/MobileEdit';
import MobileDelete from '../../assets/svg/MobileDelete';
import { successToaster } from '../../components/toaster/Toaster';

function ManageApplications() {
  const navigate = useNavigate();
  const [applicationList, setApplicationList] = useState();
  const { getApplications, deleteApplication, isLoading } = useApplicationAPI();
  const { searchValue, setSearchValue, searchHelper } = useSearchHook();

  const columns = [
    {
      width: '50%',
      key: 'name',
      title: 'Applications',
      isSortable: true,
      rowRender: (rowData) => <span> {rowData?.name} </span>,
    },
    {
      width: '25%',
      key: 'code',
      columClassName: 'whitespace-nowrap',
      title: 'Application Code',
      rowRender: (rowData) => <span> {rowData?.code} </span>,
    },
    {
      width: '25%',
      key: 'actions',
      title: 'Actions',
      columClassName: 'flex justify-end',
      rowRender: (rowData) => (
        <div>
          {/* Mobile */}
          <div className='flex items-center justify-end gap-6 break:hidden'>
            <div onClick={() => onClickEdit(rowData?.id)}>
              <MobileEdit />
            </div>
            <div onClick={() => onClickDelete(rowData?.id)}>
              <MobileDelete />
            </div>
          </div>

          {/* Desktop */}
          <div className='hidden gap-4 break:flex'>
            <NButton
              className='action-edit-btn'
              variant='outlined'
              startIcon={<EditIcon />}
              onClick={() => onClickEdit(rowData?.id)}
            >
              Edit
            </NButton>
            <NButton
              className='action-delete-btn'
              variant='outlined'
              startIcon={<DeleteIcon />}
              onClick={() => onClickDelete(rowData?.id)}
            >
              Delete
            </NButton>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const response = await getApplications();
      setApplicationList(response);
    } catch {}
  };

  const onClickEdit = (id) => {
    navigate(`${RouteEnums.APPLICATION_EDIT}/${id}`);
  };

  const onClickDelete = (id) => {
    const response = window.confirm('Press ok to delete application?');
    if (response) handleDeleteApplication(id);
  };

  const handleDeleteApplication = async (applicationId) => {
    try {
      const response = await deleteApplication(applicationId);
      if (!response) return;
      successToaster(response?.message || 'Deleted Successfully');
      fetchApplications();
    } catch {}
  };

  const getRecords = () => {
    if (searchValue) {
      return searchHelper(applicationList, ['name']);
    }
    return applicationList || [];
  };

  return (
    <section className='n-table-wrapper'>
      {/* Mobile Header */}
      <div className='break:hidden'>
        <div className='mb-4 flex items-center justify-between'>
          <h2 className='font-semibold'>Application</h2>
          <div>
            <div>
              <NButton variant='Noutline' onClick={() => navigate(RouteEnums.APPLICATION_ADD)}>
                Add Application
              </NButton>
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <NSearch value={searchValue} onChange={(e) => setSearchValue(e?.target?.value)} />
        </div>
      </div>

      {/* Desktop Header */}
      <div className='mb-10 hidden w-full flex-wrap items-start justify-between gap-4 break:flex'>
        <div>
          <NSearch value={searchValue} onChange={(e) => setSearchValue(e?.target?.value)} />
        </div>
        <div>
          <NButton onClick={() => navigate(RouteEnums.APPLICATION_ADD)}>Add Application</NButton>
        </div>
      </div>

      <div className={`${!isLoading ? 'ntable-container' : ''}`}>
        <NTable2 isLoading={isLoading} rows={getRecords()} columns={columns} />
      </div>
    </section>
  );
}

ManageApplications.propTypes = {};

export default ManageApplications;
